import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

const Product = () => {
  const [form, setForm] = useState({ subcategory_id: "", product_name: "", product_type: "general" });
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [editId, setEditId] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const created_by = localStorage.getItem("id");
  const schoolId = localStorage.getItem("school_id");
  const categoryURL = `https://dgps.co.in/api/product/category/list?school_id=${schoolId}`;
  const subcategoryURL = `https://dgps.co.in/api/product/subcategory/list`;
  const baseURL = "https://dgps.co.in/api/product";
  const addURL = `${baseURL}/add`;
  const updateURL = `${baseURL}/update`;
  const deleteURL = `${baseURL}/delete`;

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const res = await fetch(categoryURL);
      const data = await res.json();
      setCategories(data || []);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  // Fetch subcategories
  const fetchSubcategories = async (categoryId) => {
    if (!categoryId) {
      setSubcategories([]);
      return;
    }
    try {
      const res = await fetch(`${subcategoryURL}?category_id=${categoryId}`);
      const data = await res.json();
      setSubcategories(data || []);
    } catch (err) {
      console.error("Error fetching subcategories:", err);
    }
  };

  // Fetch products
  const fetchProducts = async (subcategoryId) => {
    if (!subcategoryId) {
      setProducts([]);
      return;
    }
    try {
      const res = await fetch(`${baseURL}/list?school_id=${schoolId}&subcategory_id=${subcategoryId}`);
      const data = await res.json();
      setProducts(data || []);
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Handle changes
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCategoryChange = (e) => {
    const categoryId = e.target.value;
    setForm({ ...form, category_id: categoryId, subcategory_id: "" });
    fetchSubcategories(categoryId);
    setProducts([]); // clear products until subcategory chosen
  };

  const handleSubcategoryChange = (e) => {
    const subId = e.target.value;
    setForm({ ...form, subcategory_id: subId });
    fetchProducts(subId);
  };

  // Save product
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...form, school_id: schoolId, created_by : created_by };

    try {
      if (editId) {
        payload.id = editId;
        await fetch(updateURL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } else {
        await fetch(addURL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      }
      setForm({ category_id: "", subcategory_id: "", product_name: "", product_type: "general" });
      setEditId(null);
      fetchProducts(payload.subcategory_id);
    } catch (err) {
      console.error("Error saving product", err);
    }
  };

  // Edit product
  const handleEdit = (item) => {
    setForm({
      category_id: item.category_id,
      subcategory_id: item.subcategory_id,
      product_name: item.product_name,
      product_type: item.product_type,
    });
    setEditId(item.id);
    fetchSubcategories(item.category_id);
    fetchProducts(item.subcategory_id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Delete product
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;
    try {
      await fetch(deleteURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      fetchProducts(form.subcategory_id);
    } catch (err) {
      console.error("Delete error", err);
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <div style={{ flex: 1, backgroundColor: "#f4f6f8" }}>
        <main style={{ padding: "30px", maxWidth: "1000px", margin: "auto", marginTop: "0px" }}>
          {/* Add/Edit Product Section */}
          <section style={cardStyle}>
            <h2 style={titleStyle}>{editId ? "✏️ Edit Product" : "➕ Add New Product"}</h2>
            <form onSubmit={handleSubmit}>
              <div style={formGrid}>
                {/* Category Dropdown */}
                <FormGroup label="Select Category">
                  <select
                    name="category_id"
                    value={form.category_id || ""}
                    onChange={handleCategoryChange}
                    style={fullWidthInput}
                    required
                  >
                    <option value="">-- Select Category --</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.category_name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                {/* Subcategory Dropdown */}
                <FormGroup label="Select Subcategory">
                  <select
                    name="subcategory_id"
                    value={form.subcategory_id || ""}
                    onChange={handleSubcategoryChange}
                    style={fullWidthInput}
                    required
                  >
                    <option value="">-- Select Subcategory --</option>
                    {subcategories.map((sub) => (
                      <option key={sub.id} value={sub.id}>
                        {sub.subcategory_name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                {/* Product Name */}
                <FormGroup label="Product Name">
                  <input
                    type="text"
                    name="product_name"
                    value={form.product_name}
                    onChange={handleChange}
                    style={fullWidthInput}
                    required
                  />
                </FormGroup>

                {/* Product Type */}
                <FormGroup label="Product Type">
                  <select
                    name="product_type"
                    value={form.product_type}
                    onChange={handleChange}
                    style={fullWidthInput}
                  >
                    <option value="general">General</option>
                    <option value="book">Book</option>
                    <option value="dress">Dress</option>
                    <option value="shoes">Shoes</option>
                  </select>
                </FormGroup>
              </div>

              <div style={{ textAlign: "right", marginTop: "20px" }}>
                <button type="submit" style={buttonStyle}>
                  {editId ? "Update Product" : "Add Product"}
                </button>
              </div>
            </form>
          </section>

          {/* Product List */}
          <section style={cardStyle}>
            <h2 style={titleStyle}>📋 All Products</h2>
            {products.length === 0 ? (
              <p>No products found.</p>
            ) : (
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {products.map((item, idx) => (
                  <li
                    key={item.id}
                    style={{
                      marginBottom: "15px",
                      padding: "15px",
                      borderRadius: "8px",
                      background: idx % 2 === 0 ? "#f9f9f9" : "#eef3f9",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <strong style={{ fontSize: "16px", color: "#333" }}>{item.product_name}</strong>
                      <div style={{ color: "#777", fontSize: "13px" }}>
                        Type: {item.product_type} | Subcategory: {item.subcategory_name}
                      </div>
                    </div>
                    <div>
                      <FaEdit
                        onClick={() => handleEdit(item)}
                        style={{
                          color: "#0077cc",
                          cursor: "pointer",
                          marginRight: "15px",
                        }}
                      />
                      <FaTrash
                        onClick={() => handleDelete(item.id)}
                        style={{ color: "red", cursor: "pointer" }}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </section>
        </main>
      </div>
    </div>
  );
};

// Reusable FormGroup
const formGrid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "20px",
};

const fullWidthInput = {
  width: "100%",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "15px",
  boxSizing: "border-box",
};

const FormGroup = ({ label, children, style }) => (
  <div style={{ ...style }}>
    <label
      style={{
        marginBottom: "6px",
        display: "block",
        fontWeight: 500,
        color: "#444",
      }}
    >
      {label}
    </label>
    {children}
  </div>
);

const buttonStyle = {
  padding: "10px 25px",
  backgroundColor: "#0077cc",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontSize: "15px",
  cursor: "pointer",
};

const cardStyle = {
  background: "#ffffff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
  marginBottom: "30px",
};

const titleStyle = {
  color: "#0077cc",
  marginBottom: "25px",
};

export default Product;
